module.exports = __webpack_public_path__ + "media/theme_day.549fa47c.mp3";